import { QuestionCard } from './components/questionCard'
import { Box, Typography, IconButton } from '@mui/material'
import { useStyles } from './styles'
import { SectionData } from '../../../../../../service/questionarie/response'
import CustomAccordion from '../../../../../../components/accordion'
import { useState } from 'react'

export const SectionCard = ({ title, percentage, sumCorrectOption, totalScoreCorrect, questions }: SectionData) => {
  const styles = useStyles()
  const [expand, setExpand] = useState<boolean>(true)
  return (
    <>
      <CustomAccordion
        accordionProps={{ sx: styles.accordion }}
        title={
          <>
            <Box sx={styles.container}>
              <Typography variant='blue_title'>{title}</Typography>
              <Box sx={styles.right}>
                <Typography sx={styles.porcentaje({ porcentaje: percentage })}>{percentage}%</Typography>
                <Typography sx={styles.completado}>({sumCorrectOption}/{totalScoreCorrect})</Typography>
              </Box>
            </Box>
            {expand && <Box sx={styles.borderB} />}
          </>
        }
        description={
          <>
            {questions.map((question, index) => (
              <QuestionCard key={index} title={question.title} answers={question.answers} />
            ))}
          </>
        }
        onChange={() => { setExpand(!expand) }}
        expanded={expand}
      />
    </>
  )
}
